import { Card } from "antd";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const ComponentToPrint = React.forwardRef((props, ref) => {
  function DescriptionComponent({ description }) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  return (
    <div ref={ref} className="address-print">
      <Container fluid>
        <div className="order-details-pg">
          <Row>
            <div>
              <div className="shipping-address mt-2">
                <h4>To:</h4>
                {props.pageDetails?.address?.name && (
                  <div className="d-flex justify-content-between">
                    <div>
                      <p>{props.pageDetails.address.name}</p>
                      <p>{props.pageDetails.address.address},</p>
                      <p>
                        {props.pageDetails.address.city}-
                        {props.pageDetails.address.zip}
                      </p>
                      <p>Phone Number: +91 {props.pageDetails.address.phone}</p>
                    </div>
                    {props.pageDetails?.images.length > 0 && (
                      <div>
                        <img
                          width={120}
                          height={120}
                          src={`https://thecharmingtreasure.in/orders/${
                            props.pageDetails.imagesFolder
                          }/${props.pageDetails?.images[props.image]}`}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="form-address mt-4">
              <div>
                <div>
                  <div bordered={false} className="customer-details">
                    <h4>From:</h4>
                    <label className="store-name">
                      {props.pageDetails?.Shop?.name}
                    </label>
                    <p>
                      <label>Order ID :</label> {props.pageDetails?.orderId}
                    </p>
                    <p>
                      <label>Phone Number:</label> +91{" "}
                      {props.pageDetails?.Shop?.phone}
                    </p>
                  </div>
                </div>
                <div className="mt-3">
                  <div bordered={false} className="customer-details">
                    <p>
                      <label>Product :</label>{" "}
                      {props.pageDetails?.Category?.name}
                    </p>
                    <p>
                      <label>Quantity :</label> {props.pageDetails?.quantity}
                    </p>
                    {props.pageDetails?.attributesDetails.map((obj, i) => (
                      <p>
                        <label>{obj.Variant.name} : </label>
                        {obj.name}
                      </p>
                    ))}
                    <p>
                      <label>Notes :</label>{" "}
                      <DescriptionComponent
                        description={props.pageDetails?.notes}
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="/important_product.jpg"
                  alt="important product"
                  className="important_product"
                />
              </div>
            </div>
          </Row>
        </div>
      </Container>
    </div>
  );
});
